module.exports = __webpack_public_path__ + "static/media/interier-zoom.a699547f.jpg";